import { articles } from '@/mocks/articles';
import { useNavigate } from 'react-router-dom';

export default function ArticleGrid() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    window.scrollTo(0, 0);
    navigate(`/articoli/${slug}`);
  };

  return (
    <section className="py-24 md:py-32 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 bg-secondary-50 text-secondary-700 text-xs font-medium mb-5">
              Guide & Articoli
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
              Guide{' '}
              <span className="text-primary-500 italic">Itaobuy Spreadsheet</span>
            </h2>
          </div>
          <p className="text-foreground-500 text-base max-w-md">
            Guide complete, tutorial e analisi per padroneggiare Itaobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {articles.map((article) => (
            <button
              key={article.id}
              onClick={() => handleArticleClick(article.slug)}
              className="group relative flex flex-col rounded-2xl overflow-hidden bg-background-50 border border-background-200 hover:shadow-md transition-all cursor-pointer text-left w-full"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                  {article.category}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}